import cDatepicker from '../../../blocks/booking-widget/scripts/components/c-datepicker';

class FlyoutProfiles {
  elements = [];

  forms = {
    registration: window.formsId.registration,
    anniversary: window.formsId.anniversary,
    issueCard: window.formsId.issueCard,
  };

  static isInitialized = false;

  constructor() {
    this.elements = document.querySelectorAll('.flyout-profile');
    this.dropdowns = new Map();
    this.radios = new Map();
    this.customDropDowns = new Map();
    this.textFields = new Map();
    this.handleClickClose = this.handleClickClose.bind(this);

    if (this.elements.length === 0) {
      return;
    }

    this.init();

    FlyoutProfiles.isInitialized = true;
  }

  init() {
    if (FlyoutProfiles.isInitialized) {
      return;
    }

    this.initEvents();
    this.initDatepicker();
  }

  /**
   * Initialize datepicker
   */
  // eslint-disable-next-line class-methods-use-this
  initDatepicker() {
    cDatepicker();
  }

  initEvents() {
    this.elements.forEach((element) => {
      const closeButton = element.querySelector('.flyout-profile__close-button, .js-flyout-profile-close');
      const cancelButton = element.querySelector('.flyout-profile__form-actions .js-flyout-profile-cancel');
      const submitButtonPersonalInformation = element.querySelector('#flyout-profile-form-actions-submit-flyout-profile-personal-information');
      const submitButtonAnniversaryDate = element.querySelector('#flyout-profile-form-actions-submit-flyout-profile-anniversary-date');
      const submitButtonIssuePhysicalCard = element.querySelector('#flyout-profile-form-actions-submit-flyout-profile-issue-physical-card');

      element.addEventListener('click', (e) => {
        if (e.target === e.currentTarget) {
          this.handleClickClose(e);
        }
      });
      closeButton?.addEventListener('click', this.handleClickClose);
      cancelButton?.addEventListener('click', this.handleClickClose);

      const earnSettingsButtons = element.querySelectorAll('.js-earn-settings .input-radio, .js-ffp-airline .input-radio');
      earnSettingsButtons.forEach((button) => {
        button?.addEventListener('click', this.handleEarnSettings);
      });

      if (element.querySelector('.js-earn-settings')) {
        // Fired by the JMB connect/disconnect script (JMB::renderEarnSettingsSyncScript()).
        element.addEventListener('earn-settings:sync', () => FlyoutProfiles.syncEarnSettings(element));
      }

      if (element.querySelector('.js-ffp')) {
        FlyoutProfiles.syncEarnSettings(element);
      }

      submitButtonPersonalInformation?.addEventListener('click', (event) => {
        event.preventDefault();

        this.clickSubmitButtonForWpform('registration');
      });

      submitButtonAnniversaryDate?.addEventListener('click', (event) => {
        event.preventDefault();

        this.clickSubmitButtonForWpform('anniversary');
      });

      submitButtonIssuePhysicalCard?.addEventListener('click', (event) => {
        event.preventDefault();

        this.clickSubmitButtonForWpform('issueCard');
      });

      const forms = element.querySelectorAll('.js-flyout-profile-form');
      forms.forEach((form) => {
        form.addEventListener('submit', (event) => {
          this.handleFormSubmit(event, form);
        });
      });
    });
  }

  /**
   * example:
   * flyoutProfiles.openBlock(document.querySelector('#flyout-profile-personal-information'));
   */
  // eslint-disable-next-line class-methods-use-this
  openBlock(block) {
    if (window.isRegistrationComplete === false) {
      if (window.history && window.history.pushState) {
        window.history.pushState('', document.title, window.location.pathname + window.location.search);
      }
      return;
    }

    const notOpenFlyout = [
      '#benefits-flyout',
      '#anniversary-cake',
    ];

    if (notOpenFlyout.some((item) => block.closest(item))) {
      return;
    }

    const bodyTag = document.querySelector('body');

    block.classList.add('flyout-profile--open');
    const notification = document.querySelector('.flyout-profile--open .js-flyout-profile-notification');
    if (notification) {
      notification.textContent = '';
    }

    if (block.id === 'flyout-profile-menu' || block.classList.contains('flyout-profile--menu')) {
      const header = document.querySelector('.header');
      if (header) {
        header.classList.add('header--flyout-open');
        header.classList.add('header--submenu-open');
      }
    }

    if (bodyTag) {
      bodyTag.style.overflow = 'hidden';
    }

    // Push GTM flyout virtual pageview event
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'flyout_virtual_pv',
      });
    }

    const dropdowns = block.querySelectorAll('select');
    dropdowns.forEach((dropdown) => {
      this.dropdowns.set(dropdown, dropdown.value);
    });

    const radios = block.querySelectorAll('input[type=radio]:checked');
    radios.forEach((radio) => {
      this.radios.set(radio, radio.value);
    });

    const customDropDowns = block.querySelectorAll('.js-custom-select li.active');
    customDropDowns.forEach((dropdown) => {
      const { value } = dropdown.dataset;
      this.customDropDowns.set(dropdown, value);
    });

    const textFields = block.querySelectorAll('input[type=text], input[type=tel]');
    textFields.forEach((field) => {
      this.textFields.set(field, field.value);
    });
  }

  // eslint-disable-next-line class-methods-use-this
  closeBlocks() {
    const bodyTag = document.querySelector('body');
    const blocks = document.querySelectorAll('.flyout-profile');
    const mileageFlyout = document.getElementById('flyout-profile-mileage-registration');

    this.clearJalMileageExchange(mileageFlyout);

    if (window.history && window.history.pushState) {
      window.history.pushState('', document.title, window.location.pathname + window.location.search);
    } else {
      window.location.hash = '';
    }

    blocks.forEach((block) => {
      block.classList.remove('flyout-profile--open');
    });
    document.querySelector('.header')?.classList.remove('header--submenu-open');
    document.querySelector('.header')?.classList.remove('header--flyout-open');
    window.dispatchEvent(new Event('scroll'));
    bodyTag.style.overflow = 'auto';
  }

  // eslint-disable-next-line class-methods-use-this
  handleClickClose(e) {
    const block = e.target.closest('.flyout-profile');
    const bodyTag = document.querySelector('body');

    if (!block) {
      return;
    }

    this.clearJalMileageExchange(block);

    block.classList.remove('flyout-profile--open');

    if (block.id === 'flyout-profile-menu' || block.classList.contains('flyout-profile--menu')) {
      const header = document.querySelector('.header');
      if (header) {
        header.classList.remove('header--flyout-open');
        header.classList.remove('header--submenu-open');
      }
    }

    window.dispatchEvent(new Event('scroll'));

    if (window.history && window.history.pushState) {
      window.history.pushState('', document.title, window.location.pathname + window.location.search);
    } else {
      window.location.hash = '';
    }

    if (bodyTag) {
      bodyTag.style.overflow = 'auto';
    }

    this.dropdowns.forEach((value, index) => {
      const select = index;
      select.value = value;
    });

    this.radios.forEach((value, index) => {
      const radio = index;
      radio.click();
    });

    const checkboxes = block.querySelectorAll('input[type=checkbox]');
    checkboxes.forEach((checkbox) => {
      // eslint-disable-next-line no-param-reassign
      checkbox.checked = checkbox.defaultChecked;
      checkbox.dispatchEvent(new Event('change', { bubbles: true }));
    });

    const customDropDowns = block.querySelectorAll('.js-custom-select li.active');
    customDropDowns.forEach((index) => {
      const dropdown = index;
      dropdown.classList.remove('active');
    });

    this.customDropDowns.forEach((value, index) => {
      const dropdown = index;
      dropdown.click();
    });

    this.textFields.forEach((value, index) => {
      const field = index;
      field.value = value;
    });
  }

  /**
   * JAL deep-link (?from=jal) shows an exchange CTA in the mileage flyout.
   * Clear it on close so a later in-page open without the param does not reuse it.
   * Gated by the OKU-193 flag: the legacy flow keeps the button for marked JAL leads.
   */
  // eslint-disable-next-line class-methods-use-this
  clearJalMileageExchange(block) {
    if (!window.featureIsEnabled?.('OKU-193')) {
      return;
    }

    if (!block || block.id !== 'flyout-profile-mileage-registration') {
      return;
    }

    const jmbBlock = block.querySelector('#jmb-connection-block');
    if (jmbBlock) {
      jmbBlock.querySelector('.jmb__exchange')?.closest('.flyout-profile__field')?.remove();
      jmbBlock.dataset.showExchange = '0';
    }

    const url = new URL(window.location.href);
    if (url.searchParams.get('from') !== 'jal') {
      return;
    }

    url.searchParams.delete('from');
    const search = url.searchParams.toString();
    window.history.replaceState(
      null,
      '',
      url.pathname + (search ? `?${search}` : '') + url.hash,
    );
  }

  // eslint-disable-next-line class-methods-use-this
  clickSubmitButtonForWpform(nameForm) {
    const form = document.getElementById(`wpforms-form-${this.forms[nameForm]}`);
    if (form) {
      const submitButton = form.querySelector('button[type="submit"], .wpforms-submit');
      if (submitButton) {
        submitButton.click();
      }
    }
  }

  // eslint-disable-next-line class-methods-use-this
  async handleFormSubmit(e, form) {
    e.preventDefault();
    e.stopPropagation();

    let loader;
    const button = form.querySelector('button[type="submit"]');
    const notification = form.querySelector('.js-flyout-profile-notification');
    const notifications = window.document.querySelectorAll('.js-flyout-profile-notification');

    notification.classList.remove('success', 'error');

    notifications.forEach((el) => {
      const item = el;
      item.classList.remove('success', 'error');
      item.textContent = '';
    });

    try {
      if (this.validate(form) === false) {
        form.querySelectorAll('input').forEach((input) => {
          if (!input.checkValidity() && !input.classList.contains('flyout-profile__error')) {
            const error = document.createElement('div');
            error.className = 'flyout-profile__error-message';
            error.textContent = input.dataset.message;
            input.classList.add('flyout-profile__error');
            input.insertAdjacentElement('afterend', error);
          }
        });
        return;
      }

      form.querySelectorAll('input').forEach((input) => {
        input.classList.remove('flyout-profile__error');
      });

      form.querySelectorAll('.flyout-profile__error-message').forEach((el) => el.remove());

      loader = this.loaderShow(button);

      const ajaxURL = '/wp-admin/admin-ajax.php';
      const data = new FormData(form);

      form.querySelectorAll('input[type=checkbox]').forEach((cb) => {
        if (!data.has(cb.name)) {
          data.append(cb.name, '0');
        }
      });

      const response = await fetch(ajaxURL, {
        method: (form.method || 'POST').toUpperCase(),
        body: data,
        headers: { accept: 'application/json' },
      });

      const contentType = response.headers.get('content-type');
      let responseData;

      if (!response.ok) {
        notification.classList.add('error');
        notification.textContent = response.message;

        throw new Error(`HTTP ${response.status}`);
      }

      if (contentType && contentType.includes('application/json')) {
        responseData = await response.json();
      }

      notification.classList.add(responseData.data.status);
      notification.textContent = responseData.data.message;

      if (responseData.data.status !== 'success') {
        return;
      }

      if (form.closest('#flyout-profile-premium-selection')) {
        this.updatePremiumSelection(responseData.data, form);
        const submitBtn = form.querySelector('button[type="submit"]');
        if (submitBtn) {
          submitBtn.dataset.restricted = 'true';
          submitBtn.setAttribute('disabled', 'disabled');
        }
      }

      if (form.closest('#flyout-profile-anniversary-date')) {
        this.updateAnniversaryDateCard(responseData.data);
      }

      this.closeBlocks();
    } catch (error) {
      console.log(`${error}`);
    } finally {
      this.loaderHide(button, loader);
    }
  }

  // eslint-disable-next-line class-methods-use-this
  updatePremiumSelection(responseData, form) {
    const selectedOption = form.querySelector('.c-custom-select__options li.active');
    if (selectedOption) {
      const newLabel = selectedOption.textContent.trim();

      const updateSelectors = [
        '.date-setting-card--premium .date-setting-card__description',
        '.member-card__info-group--premium-selection .member-card__info-name',
      ];

      updateSelectors.forEach((selector) => {
        const updateBlocks = document.querySelectorAll(selector);
        if (updateBlocks) {
          updateBlocks.forEach((item) => {
            // eslint-disable-next-line no-param-reassign
            item.textContent = newLabel;
          });
        }
      });
    }
  }

  // eslint-disable-next-line class-methods-use-this
  updateAnniversaryDateCard(responseData) {
    const dashboardDescription = document.querySelector('.date-setting-card--anniversary .date-setting-card__description');
    if (!dashboardDescription) {
      return;
    }

    if (responseData.anniversaryDate && responseData.anniversaryDate.date) {
      const { date, type } = responseData.anniversaryDate;
      const formattedDate = this.formatDate(date);
      dashboardDescription.innerHTML = `${formattedDate}<br>${type}`;
      dashboardDescription.classList.add('date-setting-card__description--has-date');
    }
  }

  // eslint-disable-next-line class-methods-use-this
  formatDate(dateString) {
    const date = new Date(dateString);
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return date.toLocaleDateString('en-US', options);
  }

  // eslint-disable-next-line class-methods-use-this
  validate(form) {
    const invalid = [...form.elements].find((el) => el.hasAttribute('required') && !el.value.trim());

    if (invalid) {
      // No `required` class here: WooCommerce forms.css hides `.form-row .required`
      // (meant for the label asterisk).
      invalid.focus();
      return false;
    }

    return true;
  }

  // eslint-disable-next-line class-methods-use-this
  loaderShow(button) {
    const btn = button;
    btn.disabled = true;
    const form = btn.closest('.js-flyout-profile-form');
    const wrapper = form?.closest('.flyout-profile__wrapper');

    if (wrapper) {
      const overlay = document.createElement('div');
      overlay.classList.add('blockUI', 'blockOverlay');
      wrapper.classList.add('flyout-profile__wrapper--loading');
      wrapper.appendChild(overlay);
      return overlay;
    }

    return null;
  }

  // eslint-disable-next-line class-methods-use-this
  loaderHide(button, loader) {
    const btn = button;
    if (btn.dataset.restricted !== 'true') {
      btn.disabled = false;
    }
    const form = btn?.closest('.js-flyout-profile-form');
    const wrapper = form?.closest('.flyout-profile__wrapper');

    if (wrapper) {
      wrapper.classList.remove('flyout-profile__wrapper--loading');
    }

    loader?.remove();
  }

  // eslint-disable-next-line class-methods-use-this
  handleEarnSettings(e) {
    FlyoutProfiles.syncEarnSettings(e.target.closest('.flyout-profile'));
  }

  /**
   * Shows the FFP selection (OKU-298) for Miles, the FFP# field for MH,
   * and the JMB warning when Miles go to an unlinked JMB account.
   */
  static syncEarnSettings(block) {
    if (!block) {
      return;
    }

    const button = block.querySelector('button[type="submit"]');
    const milesWarning = block.querySelector('.js-miles-warning');
    const ffp = block.querySelector('.js-ffp');
    const isMiles = block.querySelector('.js-earn-settings .input-radio:checked')?.value === 'Miles';
    // Without the FFP selection Miles always go to JMB.
    const airline = ffp ? block.querySelector('.js-ffp-airline .input-radio:checked')?.value : 'JL';

    if (ffp) {
      // Airline radios stay enabled while hidden: handleClickClose() restores them via click(),
      // which is ignored on disabled inputs. The server ignores the airline for Points.
      ffp.hidden = !isMiles;

      // JMB is linked via Mileage Registration; any other FFP is entered by number.
      const needsNumber = isMiles && Boolean(airline) && airline !== 'JL';
      const numberRow = ffp.querySelector('.js-ffp-number');
      const numberInput = numberRow?.querySelector('input');

      if (numberRow) {
        numberRow.hidden = !needsNumber;
      }

      if (numberInput) {
        numberInput.disabled = !needsNumber;
        numberInput.required = needsNumber;
      }
    }

    // The earning miles link is about JAL Miles, so it is shown only while JMB is the selected FFP.
    const earningMilesLink = block.querySelector('.js-earning-miles-link');

    if (earningMilesLink) {
      earningMilesLink.hidden = airline !== 'JL';
    }

    const needsJmb = Boolean(milesWarning) && isMiles && airline === 'JL';

    milesWarning?.classList.toggle('flyout-profile__warning--visible', needsJmb);

    if (button) {
      button.disabled = needsJmb;
    }
  }
}

export default FlyoutProfiles;
